export const BusinessCenter = () => {
  return (
    <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.0903 16.0586H8.50005C7.94777 16.0586 7.50005 16.5063 7.50005 17.0586V29.0013C7.50005 29.5536 7.94777 30.0013 8.50005 30.0013H25.0903C25.6426 30.0013 26.0903 29.5536 26.0903 29.0013V17.0586C26.0903 16.5063 25.6426 16.0586 25.0903 16.0586Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6255 30.0005V13.5348C20.6255 12.9713 20.4105 12.4309 20.0277 12.0324C19.6448 11.634 19.1256 11.4102 18.5843 11.4102H15.012C14.4706 11.4102 13.9514 11.634 13.5686 12.0324C13.1858 12.4309 12.9707 12.9713 12.9707 13.5348V30.0005"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3423 13.0996H32.501C33.0533 13.0996 33.501 13.5473 33.501 14.0996L33.501 21.3986C33.501 21.9509 33.0533 22.3986 32.501 22.3986H28.5416"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.8565 22.3986V11.417C29.8565 11.0412 29.7131 10.6808 29.4578 10.415C29.2025 10.1493 28.8562 10 28.4951 10H26.1126C25.7516 10 25.4053 10.1493 25.15 10.415C24.8947 10.6808 24.7512 11.0412 24.7512 11.417L24.7696 12.6568"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
